import { render, staticRenderFns } from "./contaBancaria.vue?vue&type=template&id=5153a435&scoped=true&"
import script from "./contaBancaria.vue?vue&type=script&lang=js&"
export * from "./contaBancaria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5153a435",
  null
  
)

export default component.exports